export function getEnhancedYouTubeTranscript(content: string): string | null | undefined {
  const htmlDoc = new DOMParser().parseFromString(content, 'text/html');
  const scriptElement = htmlDoc.querySelector('script.rw-enhanced-youtube-transcript');
  if (!scriptElement) {
    return;
  }
  return scriptElement.textContent;
}
